import React from "react";
import { useFormikContext } from "formik";
import FormikInput from "../../Formik/FormikInput";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";
import SubcriptionDetails from "./SubcriptionDetails";

const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
`;
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }
`;
const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 130px;
  height: 35px;
  margin-right: 20px;
  margin-top: 25px;
`;

const CreateBranch = () => {
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <div>
      <div className="container" style={{ maxWidth: "900px", padding: "10px" }}>
        <FormContainer className="row g-3 px-2">
          <h3 className="modal-title mb-2">{t["Create Branches"]}</h3>

          <div className="col-md-10">
            <StyledLabel className="form-label">{t["Name"]}</StyledLabel>
            <FormikInput type="text" name="name" />
          </div>
          <div className="col-md-4">
            <StyledLabel className="form-label">{t["Street"]}</StyledLabel>
            <FormikInput type="number" name="street" />
          </div>
          <div className="col-md-4">
            <StyledLabel className="form-label">{t["City"]}</StyledLabel>
            <FormikInput name="city" />
          </div>
          <div className="col-md-4">
            <StyledLabel className="form-label">{t["Zip"]}</StyledLabel>
            <FormikInput type="number" name="zip" />
          </div>
          <div className="col-md-6">
            <StyledLabel
              htmlFor="OpportunityName"
              className="form-label"
              defaultValue=""
            >
              {t["Country"]}
            </StyledLabel>
            <FormikInput name="country_id" />
          </div>
          <div className="col-md-6">
            <StyledLabel className="form-label">{t["Phone"]}</StyledLabel>
            <FormikInput type="email" name="email" />
          </div>
          <SubcriptionDetails />

          <div className="d-flex justify-content-end">
            <ActionButton>{t["Discard"]}</ActionButton>
            <ActionButton>{t["Save & New"]}</ActionButton>
            <ActionButton>{t["Save & Close"]}</ActionButton>
          </div>
        </FormContainer>
      </div>
    </div>
  );
};

export default CreateBranch;
